/*global Oidc:false*/
// OpenID Connect service responsible for authenticating the user and maintaining the user session via "silent refresh"
// Uses the OpenID Connect library
(function (Oidc) {
    angular
        .module('service.Authentication')
        .service('gfOIDCService', ['localStorageService', '$timeout', '$log', '$window', '$location', '$http', '$rootScope', '$q', 'authenticationService', 'configuration', 'storageKeys', 'userService', 'storeService',
            function (localStorageService, $timeout, $log, $window, $location, $http, $rootScope, $q, authenticationService, configuration, storageKeys, userService, storeService) {

            var isAuthorized = false;
            var completedLogin = $q.defer();

            this.isConnected = isAuthorized;
            this.logout = logout;
            this.completedLogin = completedLogin.promise;
            this.impersonate = impersonate;
            this.initialize = initialize
            this.getNewToken = getNewToken
            var isConfigured = false
            var userManager = undefined
            var settings = undefined;
            this.signinRedirect = signinRedirect;
            ////////////
            $log.debug("gfOIDCService: Initializing")
            // Uncomment these to get some information about authentication
            // Do not leave this in production
            Oidc.Log.level = Oidc.Log.INFO
            Oidc.Log.logger = console

            var silentRenewTries = 0;
            var deauthorizedOn;

            if (configuration.isInitialized()) {
                settings = configure()
            }

            function configure() {
                isConfigured = true
                var settings = {
                    authority: configuration.authority,
                    client_id: "Etech.VegasWeb",
                    redirect_uri: $window.location.protocol + "//" + $window.location.host + "/gf-servicemanager-tablet",
                    post_logout_redirect_uri: localStorageService.get(storageKeys.loginTypeKey) === 'ENGINEER'
                        ? $window.location.protocol + "//" + $window.location.host + "/gf-servicemanager-tablet/user-login.jsp"
                        : $window.location.protocol + "//" + $window.location.host + "/gf-servicemanager-tablet",

                    // these two will be done dynamically from the buttons clicked, but are
                    // needed if you want to use the silent_renew
                    response_type: "id_token token",
                    scope: "openid Etech.VegasWeb Etech.VegasApi Etech.PublicApi",

                    // silent renew will get a new access_token via an iframe
                    // just prior to the old access_token expiring (60 seconds prior)
                    silent_redirect_uri: $window.location.protocol + "//" + $window.location.host + "/gf-servicemanager-tablet/silent_renew.html",
                    automaticSilentRenew: true,
					silentRequestTimeout: 30000,
                    // will raise events for when user has performed a logout at IdentityServer
                    monitorSession: true,

                    // this will allow all the OIDC protocol claims to be visible in the window. normally a client app
                    // wouldn't care about them or want them taking up space
                    filterProtocolClaims: true,

                    // this will use the user info endpoint if it's an OIDC request and there's an access_token
                    loadUserInfo: true
                };

                userManager = new Oidc.UserManager(settings);

                userManager.events.addUserUnloaded(function (data) {
                    $log.debug("auth: user unloaded");
                    $log.debug("user unloaded -"+JSON.stringify(data));
                });
                userManager.events.addAccessTokenExpiring(function () {
                    $log.debug("auth: token expiring");
                });
                userManager.events.addUserSignedOut(function () {
                    $log.debug("auth: user signed out, trying silent renew");
                    trySilentRenew("auth: user signed out")
                });

                userManager.events.addUserLoaded(function (user) {
                    $log.debug("auth: user loaded");
                    $log.debug("user loaded -"+JSON.stringify(user));
                    var profile = user.profile;
                    // this happens when we already have a session with a valid user
                    // in the meantime in another tab user logs in another app using Cas provider
                    // on the current app user manager silently logs in and loads the invalid user
                    /*if ("idp" in profile && profile.idp === 'Cas') {
                        $log.warn("auth: invalid user loaded")
                        $rootScope.$emit("event:auth-invalidUserLoaded", {message:"User is not authorized to use this application: " + user.profile.sub,code:403})
                        return
                    }*/

                    if(profile && profile["hki.claims.impersonator"]){
                        $rootScope.$broadcast('event:impersonatorloaded',true);
                        localStorageService.set(storageKeys.impersonatedKey,true);
                    }else{
                        localStorageService.set(storageKeys.impersonatedKey,false);
                    }

                    setAuthorization(user)
                });

                userManager.events.addAccessTokenExpired(function () {
                    $log.error('auth: deauthorized')
                    isAuthorized = false;
                    $rootScope.$broadcast('auth:isAuthorized', isAuthorized)
                    deauthorizedOn = new Date()
                });

                userManager.events.addSilentRenewError(trySilentRenew);

                return settings;
            }


            function initialize() {
                if (!isConfigured) {
                    $log.error("auth: not configured")
                    completedLogin.reject("auth: not configured")
                    return
                }
                $log.debug('auth: starting')
                var path = $location.path()

                var errIdx = path.indexOf('error=');
                var signInIdx = path.indexOf('id_token')
                if (errIdx !== -1) {
                    $log.debug('auth: found error hash')
                    angular.forEach(path.substr(errIdx).split('&'), function (element) {
                        if (element.startsWith('error=')) {
                            throw "Failed to authenticate '" + element + "'"
                        }
                    })
                } else if (signInIdx !== -1) {
                    $log.debug('auth: found login token after hash')
                    userManager.signinRedirectCallback(path.substr(signInIdx))
                        .then(navigateToPathSetBeforeRedirect)
                        .catch(function (err) {
                            $log.debug('auth: ' + err)
                            if (isClockSkewError(err)) {
                                completedLogin.reject({message: 'knownErrors.ClockSkew'})
                            } else {
                                completedLogin.reject(err)
                            }

                            throw err
                        })
                } else {
                    $log.debug('auth: nothing in path, checking for user information in browser storage')
                    clearRedirectPathSetBeforeRedirect()

                    userManager.getUser().then(function (user) {
                        if (!user || user.expired) {
                            // if user lands on different session this will try
                            // to get the existing valid token from the auth
                            $log.debug("auth: user not found in storage, trying silent sign in")
                            userManager.signinSilent()
                                .then(function (result) {
                                    // after succesfull silent sign in UserLoaded event will fire which will set the auth profile
                                    $log.debug("auth: silent sign in success", result)
                                })
                                .catch(function (error) {
                                    $log.warn("auth: failed to silent renew, redirecting to the login page", error)
                                    if (error.error === 'login_required') {
                                        completedLogin.reject({message: "User not logged in"})
                                    }
                                });
                        } else {
                            $log.debug('auth: found a user in browser storage')
                            setAuthorization(user)
                        }
                    })
                }
            }

                function impersonate(userName) {
                    userManager.clearStaleState()
                        .then(function () {
                            savePathBeforeRedirect();
                            userManager.removeUser();
                        })
                        .then(function () {
                            settings.prompt = 'login'
                            if (angular.isDefined(userName)) {
                                settings.acr_values = 'Impersonate:' + userName
                            }

                            userManager = new Oidc.UserManager(settings)
                            userManager.signinRedirect().then(function () {
                                $log.info("impersonation succeeded");
                                completedLogin.resolve();
                            }, function (e) {
                                $log.info("impersonation failed");
                                completedLogin.reject(e);
                            });
                        });
                }

            function getNewToken(userName) {
                if (!isConfigured) {
                    $log.error("auth: not configured")
                    return
                }

                var additionalOptions = {}
                if (userName) {
                    additionalOptions.login_hint = userName
                }
                userManager.clearStaleState();
                savePathBeforeRedirect()
                userManager.signinRedirect(additionalOptions)
                    .then(null, function (e) {
                        $log.info("auth failed: " + e);
                        //TODO: App insights
                        completedLogin.reject(e);
                    });
            }

            function signinRedirect(userName){
                if (!isConfigured) {
                    $log.error("auth: not configured")
                    return
                }

                var additionalOptions = {}
                if (userName) {
                    additionalOptions.login_hint = userName
                    additionalOptions.display = "page";
                }
                userManager.clearStaleState();
                savePathBeforeRedirect($window.location.href)
                userManager.signinRedirect(additionalOptions)
                    .then(null, function (e) {
                        $log.info("auth failed: " + e);
                        //TODO: App insights
                        completedLogin.reject(e);
                    });
            }

            function savePathBeforeRedirect(path) {
                try {
                    if(path){
                        localStorageService.set(storageKeys.savedPathKey, path);
                    }else {
                        localStorageService.set(storageKeys.savedPathKey, $location.path());
                    }
                    console.log("Saved path before redirect  - "+ localStorageService.get(storageKeys.savedPathKey));
                } catch (e) {
                    completedLogin.reject(e)
                    throw e
                }
            }

            function navigateToPathSetBeforeRedirect() {
                var path = localStorageService.get(storageKeys.savedPathKey);
                clearRedirectPathSetBeforeRedirect()

                console.log("path - "+path);
                if (!angular.isString(path)) {
                    $log.info("auth: no path provided from before redirect")
                } else {
                    $log.info("auth: redirecting to " + path)
                    $location.path(path)
                }
            }

            function clearRedirectPathSetBeforeRedirect() {
                localStorageService.remove(storageKeys.savedPathKey);
            }

            function setAuthorization(user) {
                // set local storage data with data from the token
                var localProfile = authenticationService.setApplicationUserContext(user);

                if (authenticationService.isStoreUser()) {
                    userService.userList(storeService.getStore().id).then(function (resource) {
                        resource.$get("userList").then(function (list) {
                            var loggedInUserInStoreUsers = list.filter(function (user) {
                                return user.username === localProfile.username;
                            })[0];

                            if (loggedInUserInStoreUsers) {
                                authorize(user, localProfile);
                            } else {
                                completedLogin.reject({message:"User is not authorized to use this application: " + localProfile.username, code:403});
                                return;
                            }
                        });
                    });
                } else {
                    authorize(user, localProfile);
                }
            }

            function authorize(user, localProfile) {
                var token = user.token_type + " " + user.access_token;
                $http.defaults.headers.common.Authorization = token
                $rootScope.$broadcast('auth:newToken', token)
                $log.debug('auth: completed login')

                // check if the user has valid roles or the token issued is invalid(issued by CAS)
                if ((authenticationService.isEngineer() || authenticationService.isStoreUser()) /*&& !localProfile.casLogin*/) {
                    // sets login type according to the user role
                    // this will ensure the tablet is in the right mode
                    authenticationService.setLoginType()
                    // set custom store header required by the API
                    authenticationService.setCustomStoreContextHeader()
                    // gets user profile from the API, checks for service provider presence
                    authenticationService.getUserProfileDetails(localProfile)
                    completedLogin.resolve();
                    isAuthorized = true;
                    silentRenewTries = 0;
                    if (deauthorizedOn) {
                        $rootScope.$broadcast('auth:isAuthorized', isAuthorized)
                        var duration = (new Date() - deauthorizedOn) / 1000
                        $log.info("auth: reauthorized after " + duration + 's')
                        deauthorizedOn = undefined;
                    }
                }else if(authenticationService.isAdmin()){
                    // sets login type according to the user role
                    // this will ensure the tablet is in the right mode
                    authenticationService.setLoginType()

                    authenticationService.getUserProfileDetails(localProfile)
                    completedLogin.resolve();
                    isAuthorized = true;
                    silentRenewTries = 0;
                    if (deauthorizedOn) {
                        $rootScope.$broadcast('auth:isAuthorized', isAuthorized)
                        var duration = (new Date() - deauthorizedOn) / 1000
                        $log.info("auth: reauthorized after " + duration + 's')
                        deauthorizedOn = undefined;
                    }
                } else {
                    completedLogin.reject({message:"User is not authorized to use this application" + localProfile.username,code:403})
                }
            }

            function logout() {
                authenticationService.cleanLocalStorage()
                userManager.signoutRedirect();
            }

            function trySilentRenew(e) {
                if (angular.isUndefined(e)) {
                    e = {error: '', message: ''}
                }

                $log.debug("auth: silent renew error " + ++silentRenewTries, e.message);
                if (e.error === 'login_required') {
                    logout()
                }

                // Continuously try to sign in again if the token has expired and we have a connection error
                userManager.signinSilent()
                    .catch(function (error) {
                        if (e.error === 'login_required') {
                            $log.warn('auth: silent renew fail, login required')
                            logout()
                        }
                        var trySilentRenewIn = Math.min(silentRenewTries, 30);
                        $log.debug('auth: trying to renew again in ' + trySilentRenewIn + 's')
                        $timeout(function () {
                            trySilentRenew(error)
                        }, trySilentRenewIn * 1000)
                    });
            }
        }])

    function isClockSkewError(err) {
        return err && angular.isString(err.message) &&
            (err.message.startsWith('exp is in the past') || err.message.startsWith('iat is in the future'))
    }

})(Oidc);